/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { PropertyResource } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface IndexPublicPropertyServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * List of public properties
     * Filter by &#x60;type&#x60;, &#x60;status&#x60;, &#x60;userId&#x60;, &#x60;externalUserId&#x60;. Example &#x60;/properties?filter[type]&#x3D;1&#x60;
     * @param perPage 
     * @param page 
     */
    getPublicProperties(perPage?: number, page?: string, extraHttpRequestParams?: any): Observable<Array<PropertyResource>>;

}
